"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapWith = wrapWith;
exports.wrap = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _omit2 = _interopRequireDefault(require("lodash/omit"));

var _reactDisplayName = _interopRequireDefault(require("react-display-name"));

/**
 * Field is designed to be used to wrap the Form-related components.
 *
 * It serves as a common container around any component that ends in "Field":
 * `InputField`, `SelectField`, `RadioGroupField`, `TextAreaField`, `CheckboxField`, etc.
 * The props of `Field` exist on each of these components.
 *
 */
var Field =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Field, _React$Component);

  function Field() {
    (0, _classCallCheck2["default"])(this, Field);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Field).apply(this, arguments));
  }

  (0, _createClass2["default"])(Field, [{
    key: "render",
    value: function render() {
      var field,
          errorComponent,
          helpComponent,
          props = this.props,
          isCheckbox = this.props.type === 'checkbox',
          label;
      var labelClass = (0, _classnames["default"])({
        'zsg-toolbar-label': props.toolbar && !isCheckbox
      }) || null; // Only have a label if label text is given

      if (props.label) {
        label = _react["default"].createElement("label", {
          htmlFor: props.id,
          className: labelClass
        }, props.label);
      } // Tooltip next to label


      if (props.tooltip) {
        label = _react["default"].createElement("div", {
          className: "zsg-form-label"
        }, label, props.tooltip);
      }

      if (props.errorText) {
        errorComponent = _react["default"].createElement("p", {
          className: "zsg-form-error-text"
        }, props.errorText);
      }

      if (props.helpText) {
        helpComponent = _react["default"].createElement("div", {
          className: "zsg-content-component zsg-form-help-text"
        }, props.helpText);
      }

      var fieldClass = (0, _classnames["default"])(props.className, 'zsg-form-field', {
        'zsg-form-field_error': props.error,
        'zsg-form-field_checkbox': isCheckbox,
        'zsg-toolbar-form-field': props.toolbar
      });
      field = _react["default"].createElement("div", {
        className: fieldClass
      }, isCheckbox ? this.props.children : label, isCheckbox ? label : this.props.children, errorComponent, helpComponent);
      return field;
    }
  }]);
  return Field;
}(_react["default"].Component);

Field.displayName = 'Field';
Field.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * required unique string for the field
   */
  id: _propTypes["default"].string.isRequired,

  /**
   * additional classes to add to the `zsg-form-field` element
   */
  className: _propTypes["default"].string,

  /**
   * currently stored value
   */
  value: _propTypes["default"].any,

  /**
   * rendered in the label element
   */
  label: _propTypes["default"].node,

  /**
   * marks field with an error
   */
  error: _propTypes["default"].bool,

  /**
   * description of error
   */
  errorText: _propTypes["default"].node,

  /**
   * inserted after label text
   */
  tooltip: _propTypes["default"].node,

  /**
   * passed when inside of a Toolbar
   */
  toolbar: _propTypes["default"].bool,

  /**
   * checkboxes are rendered before label, so Field needs to know
   */
  type: _propTypes["default"].oneOf(['button', 'checkbox', 'color', 'date', 'datetime', 'datetime-local', 'email', 'hidden', 'month', 'number', 'password', 'radio', 'range', 'search', 'submit', 'tel', 'text', 'time', 'url', 'week']),

  /**
   * grey text below element
   */
  helpText: _propTypes["default"].node,
  children: _propTypes["default"].node
} : {};
var _default = Field;
exports["default"] = _default;
var blackList = ['className', 'error', 'errorText', 'helpText', 'label', 'tooltip'];

function filterChildProps(props) {
  return (0, _omit2["default"])(props, blackList);
} // Helper function for using Wrapper as a higher-order component


function wrapWith() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$fieldProps = _ref.fieldProps,
      fieldProps = _ref$fieldProps === void 0 ? {} : _ref$fieldProps;

  return function (WrappedComponent) {
    // To be recognized by findAllExportedComponentDefinitions resolver,
    // this HOC needs to be a "rightmost-unary" style HOC.
    // some people apparently consider this "correct", so ¯\_(ツ)_/¯
    // https://github.com/reactjs/react-docgen/issues/80#issuecomment-221735383
    function FieldWrapper(props) {
      var childProps = filterChildProps(props);
      return _react["default"].createElement(Field, (0, _extends2["default"])({}, props, fieldProps), _react["default"].createElement(WrappedComponent, childProps));
    }

    FieldWrapper.displayName = (0, _reactDisplayName["default"])(WrappedComponent) + "Field";
    FieldWrapper.WrappedComponent = WrappedComponent;
    return FieldWrapper;
  };
} // simpler signature for defaulted (empty) fieldProps


var wrap = wrapWith();
exports.wrap = wrap;


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/Field/index.js
// module id = 55
// module chunks = 0